import Empty from '@/assets/placeholders/empty.png';

import { WhiteLabelTheme } from '../types';

import CardBackground from './assets/card-background.svg';
import CardLogo from './assets/card-logo.svg';
import DashboardBanner from './assets/dashboard-banner.svg';
import DashboardIllustration from './assets/dashboard-illustration.svg';
import FullDashboardIllustration from './assets/full-dashboard-illustration.svg';
import LoginBackground from './assets/login-background.svg';
import LogoIcon from './assets/logo.svg';
import SmallLogoIcon from './assets/minify-logo.svg';
import SidebarLogoIcon from './assets/sidebar-logo.svg';
import SignInLogo from './assets/signIn-logo.svg';
import VerificationBanner from './assets/verificationBackground.svg';

const buttonColors = {
  buttonPrimary: '#041483',
  buttonPrimaryHover: '#04146F',
  buttonPrimaryActive: '#04143D',
  buttonPrimaryPressed: '#04146F',
  buttonPrimaryDisabled: '#EAECF9',

  buttonSecondaryHoverBorder: '#041483',
  buttonSecondaryActiveBorder: '#04143D',
  buttonSecondaryDisabledBorder: '#EAECF9',
  buttonSecondaryDisabled: '#FFFFFF',
  buttonSecondaryHover: '#EAECF9',

  buttonTertiaryHover: '#EDF0FF',
  buttonTertiaryPressed: '#DCE8FC',
  buttonTertiaryDisabled: '#E8E9EF',
  buttonSecondaryContainer: 'transparent',
};
const navigationColors = {
  navigationBackground: '#171E4D',
  navigationBorder: '#252D62',
  navigationAccent: '#4EABE9',
  navigationAccent2: '#4EABE9',
  navigationTextDefault: '#FFFFFF',
  navigationTextAccent: '#2254A0',
  navigationIconDefault: '#FFFFFF',
  navigationIconAccent: '#2254A0',
  navigationAccentHover: '#394173',
  navigationAccentActive: '#DFE3FF',
};
const backgroundColors = {
  background1: '#131940',
  background2: '#171E4D',
  background3: '#000000',

  border: '#BABABC',
  border1: '#DCDCDC',
  border2: '#EAEAEA',
  module: '#FBFAFA',
  canvas: '#FFFFFF',
  stressContainer: '#333333',
  accentActive: '#041483',
  accentBorder: '#BABABC',
  accentContainer: '#F5F7FF',
  textHighlighter: '#FFFF80',
  popupBg2: '#171E4D',
  legend: '#E2E2E2',
};

const baseColors = {
  ...buttonColors,
  ...navigationColors,
  ...backgroundColors,

  textTitle: '#0F1621',
  textBody: '#0F1621',

  textSecondary: '#6B7485',
  textDisabled: '#9BA3B3',
  textOnColor: '#FFFFFF',
  textAccent: '#041483',
  textAccentHover: '#04146F',
  textAccentActive: '#04143D',

  iconPrimary: '#0F1621',
  iconSecondary: '#6B7485',
  iconOnColor: '#FFFFFF',
  iconAccent: '#041483',
  iconAccentHover: '#04146F',
  iconAccentActive: '#04143D',
  iconDisabled: '#9BA3B3',

  success: '#19B269',
  successBorder: '#B8E7D1',
  successContainer: '#E8F7F0',

  warning: '#F9C134',
  warningBorder: '#FDECC0',
  warningContainer: '#FEF9EB',

  danger: '#E72626',
  dangerBorder: '#F8BCBC',
  dangerContainer: '#FDE9E9',
  dangerHover: '#A61C18',
  dangerActive: '#66120A',

  info: '#176AF6',
  infoBorder: '#B7D1FC',
  infoContainer: '#E8F0FE',

  transactionMedical: '#00C3B3',
  transactionDental: '#176AF6',
  transactionVision: '#481A54',
  transactionOther: '#FF9D0A',
  transactionParking: '#323D9B',
  transactionTransit: '#9BBF84',
  transactionAdoption: '#0F7970',
  transactionDependentCare: '#CC3381',
  transactionPharmacy: '#D83B00',
  transactionLifestyle: '#D3375C',
  transactionPremium: '#3628D1',
  transactionTravel: '#F26B31',
  transactionWellness: '#9B31F2',
  transactionPlanSpecific: '#00B5EE',
  refund: '#588C0E',
  transactionDefault: '#5E697E',
  claimTransferInternal: '#E5E9F0',
  nonClaimIcon: '#151F6D',
  nonClaimBg: '#E5E9F0',

  planTypeHSA: '#2EA12B',
  planTypeHCFSA: '#FA802A',
  planTypeDCAP: '#CC3381',
  planTypeHRA: '#134E8F',
  planTypeCommuterTransit: '#9BBF84',
  planTypeCommuterParking: '#323D9B',
  planTypeAdoption: '#0F7970',
  planTypeLifestyle: '#D3375C',
  planTypeSpecialty: '#00B5EE',
  planTypeTravel: '#F26B31',
  planTypeRx: '#7909AD',
  planTypeDental: '#176AF6',
  planTypeVision: '#481A54',
  planTypeMedical: '#00C3B3',

  lockedNull: '#000000',
  processingPending: '#F9C134',
  needsHelp: '#FF9D0A',
  paidActiveComplete: '#19B269',
  partiallyPaid: '#B9CC29',
  waitingForFunds: '#8EB2A1',
  deniedErrorExpired: '#E72626',
  uploading: '#9BA3B3',
  uploadedApproved: '#176AF6',
  loa: '#00B5EE',
  retirement: '#CE8258',
  future: '#7909AD',

  missingDetail: '#FB6D2A',
  missingContainer: '#FFF3EE',
  missingBorder: '#FEDACA',

  investmentsfuture: '#7909AD',
  investmentsFund1: '#3F68FF',
  investmentsFund2: '#10D8B9',
  investmentsFund3: '#FB5C20',
  investmentsFund4: '#FC990F',
  investmentsFund5: '#FDD137',
  investmentsFund6: '#BCD1EF',
  investmentsFund7: '#323D9B',
  investmentsFund8: '#F3C626',
  investmentsFund9: '#A528C6',
  investmentsFund10: '#0C95D0',
  investmentsFund11: '#619C00',
  investmentsFund12: '#CC3381',
  investmentBackground: '#131940',
  profitContainer: '#00FF9314',
  lossContainer: '#EF235D14',
  chart: '#041483',

  partner: '#D83B00',
  distributor: '#904D27',
  employer: '#174FBC',
  subsidiary: '#0F7970',
  subgroup: '#481A54',
  claimProcessor: '#176AF6',
  employee: '#0CAD09',
  dependent: '#5E1696',
  noAssignee: '#B8BFCC',

  claimParticipant: '#CC3381',
  claimSystem: '#18A0FB',
  claimCardProcessor: '#19B269',

  ancor: '#502D3C',
  ancorHover: '#422230',
  activeButtonText: '#422230',
  paginationActiveItem: '#04146F',

  tableHeader: '#502D3C',

  iconActive: '#502D3C',
  iconActiveHover: '#422230',

  investmentsProfit: '#00FF93',
  investmentsLoss: '#EF235D',
  sidebarDelimiter: '#ECECEC',
};
export default {
  title: 'Admin ABS',
  loginIconWidth: 490,
  loginIconHeight: 92,
  loginScreenTitle: 'Smarter benefits, powered by automation that works and service that cares.',
  colors: {
    ...baseColors,
    loginTitleColor: baseColors.textBody,
    popup: 'rgba(15, 22, 33, 0.5)',
    popup2: 'rgba(15, 22, 33, 0.05)',
    fade1: 'linear-gradient(0deg, #F7F9FA 0%, rgba(255, 255, 255, 0.00) 100%)',
    fade2: 'linear-gradient(180deg, #F7F9FA 0%, #EEF1F4 100%)',
  },
  logo: LogoIcon,
  minifyLogo: SmallLogoIcon,
  font: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  titleFont: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  tetriaryAccentButton: true,
  images: {
    banner: DashboardBanner,
    cardBackground: CardBackground,
    loginBackground: LoginBackground,
    cardLogo: CardLogo,

    sidebarMinifyLogo: SmallLogoIcon,
    qrCodeLogo: SmallLogoIcon,
    investmentsBannerRight: Empty,
    reimburseMeSidebar: Empty,
    verificationBackground: VerificationBanner,
    signInLogo: SignInLogo,
    manageProfileBannerBackground: Empty,
    sidebarLogo: SidebarLogoIcon,
    bannerCloud: Empty,
    lgLoginBackground: LoginBackground,
    loginBackgroundClouds: Empty,
    expressSetupBannerBackground: Empty,

    fullDashboardIllustration: FullDashboardIllustration,
    dashboardIllustration: DashboardIllustration,
  },
  fonts: {
    sidebarWeight: 500,
    sidebarFontSize: '14px',
    reimbursementWeight: 500,
    sizes: {
      small: {
        size: '12px',
        height: '16px',
        maxWidth: '336px',
      },
      '3xl': {
        size: '30px',
        height: '40px',
        maxWidth: '1008px',
      },
      '2xl': {
        size: '24px',
        height: '30px',
        maxWidth: '816px',
      },
    },
  },
  rounds: {
    moduleRound: '6px',
    container1Round: '6px',
    container2Round: '6px',
    checkboxRound: '6px',
    fieldRound: '6px',

    navigationButtonRound: '4px',
    button1Round: '28px',
    button2Round: '28px',
    dropdownItemRound: '4px',
    snackbarRound: '4px',
  },

  shadows: {
    default: '0px 6px 15px rgba(0, 0, 0, 0.04);',
    hover: '0px 8px 15px rgba(0, 0, 0, 0.10);',
    active: '0px 8px 25px rgba(4, 20, 131, 0.25);',
    highlighted: '0px 6px 16px rgba(4, 20, 131, 0.5);',
  },
  favicon: '/abs/favicon.ico',
  favicon16: '/abs/favicon-16x16.png',
  favicon32: '/abs/favicon-32x32.png',
  faviconAppleTouch: '/abs/apple-touch-icon.png',
} as WhiteLabelTheme;
